<template>
  <div class="HeaderContent">
    <div class="left-side pl-1">
      <Crumbs />
    </div>
    <div class="icons">
      <template v-if="isMobileBreakpoint">
        <dropdown-links
          v-if="isUserStaff"
          :options="mobileOptions"
          @changeRoute="navigateTo"
        >
          <icon-btn> more_vert </icon-btn>
        </dropdown-links>
      </template>
      <template v-else-if="isUserStaff">
        <dropdown-links
          v-for="item in items"
          :key="item.id"
          :options="item.options"
          @changeRoute="navigateTo"
        >
          <icon-btn>
            {{ item.icon }}
          </icon-btn>
        </dropdown-links>
      </template>
      <icon-btn v-if="!isMobile" @click="fullscreenMode"> fullscreen </icon-btn>
      <UserIcon />
    </div>
  </div>
</template>

<script>
import Crumbs from "./Crumbs.vue";
import DropdownLinks from "./DropdownLinks.vue";
import UserIcon from "./UserIcon.vue";
import IconBtn from "./IconBtn.vue";
import { eventBus } from "@/main.ts";
import { mapGetters } from "vuex";

export default {
  components: {
    Crumbs,
    DropdownLinks,
    UserIcon,
    IconBtn,
  },
  props: {
    fullscreenState: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
    },
  },
  data: () => ({
    fullscreen: false,
    user: null,
    items: [
      {
        id: 1,
        icon: "people",
        options: [
          { icon: "person", text: "Usuários", route: "users" },
          { icon: "work", text: "Grupos", route: "groups" },
        ],
      },
      {
        id: 2,
        icon: "dashboard_customize",
        options: [
          { icon: "bar_chart", text: "Metas", route: "goals" },
          { icon: "account_tree", text: "BOP", route: "bop_diagrams" },
        ],
      },
    ],
    forAutomaUsers: {
      id: 3,
      icon: "memory",
      options: [
        { text: "Broker", icon: "memory", route: "broker_debug" },
        { text: "Queryzer", icon: "memory", route: "queryzer" },
        { text: "Dados", icon: "memory", route: "consolidated_data" },
      ],
    },
  }),
  watch: {
    fullscreenState: {
      handler() {
        this.fullscreen = this.fullscreenState;
      },
    },
    isSuperUser: {
      handler() {
        this.addConfigApp();
      },
    },
  },
  mounted() {
    this.addConfigApp();
  },

  computed: {
    ...mapGetters(["isUserStaff", "isSuperUser"]),
    isMobileBreakpoint() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    mobileOptions() {
      const options = [];
      this.items.forEach((item) => {
        item.options.forEach((e) => options.push(e));
      });
      return options;
    },
  },
  methods: {
    addConfigApp() {
      if (this.isSuperUser) {
        let hasConfigApp = this.items[1].options.find(
          (e) => e.route == "config_app"
        );
        if (!hasConfigApp) {
          this.items[1].options.push({
            icon: "settings",
            text: "Config App",
            route: "config_app",
          });
        }
      }
      this.handleAutomaUsers();
    },
    handleAutomaUsers() {
      let index = this.items.findIndex((e) => e.id == 3);
      if (index !== -1) this.items.splice(index);
      if (this.isSuperUser) this.items.push(this.forAutomaUsers);
    },
    navigateTo(name = "") {
      if (name && this.$route.name !== name) {
        this.$router.push({
          name,
        });
        eventBus.$emit("notify-nav-items");
      }
    },
    changeRoute() {
      eventBus.$emit("notify-nav-items");
      this.$router.push({
        name: "config_app",
      });
    },
    fullscreenMode() {
      this.fullscreen = this.fullscreenState;
      this.fullscreen = !this.fullscreen;
      eventBus.$emit("fullscreen", this.fullscreen);
    },
  },
};
</script>
<style scoped>
.HeaderContent {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
  max-height: 100%;
}
.left-side {
  display: flex;
}
.icons {
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.icon {
  margin-right: 8px;
}
</style>
